import style from "./00_tcp.css"
import Header from '../components/header'
import Footer from '../components/footer'
export default function TermsConditions() {
    return (
    <div style={{ backgroundColor: "#FFFDF4", minHeight: "100vh" }}>
      <Header />
        <div className="legal-document">
            <h1>Terms and Conditions</h1>
            <p><strong>Last Updated:</strong> 13th August 2026</p>

            <p>Welcome to <strong>SurSaathi</strong> ("we", "us", "our"). These Terms and Conditions ("Terms") govern your use of <strong>sursaathi.in</strong> (the "Website").</p>

            <p>By accessing or using the Website, you agree to these Terms. If you do not agree with these Terms, please do not use the Website.</p>

            <h2>1. About Our Website</h2>
            <p>Our Website may provide services and features including:</p>
            <ul>
              <li>A general contact form;</li>
              <li>Instrument donation, submission, or listing forms;</li>
              <li>Music teacher registrations and teacher listings;</li>
              <li>Forms through which students or other users can request information about music teachers;</li>
              <li>Communication or information-sharing between students and teachers; and</li>
              <li>Other music-related community services and resources.</li>
            </ul>

            <h2>2. User Information</h2>
            <p>When using certain features of the Website, you may be asked to provide personal information such as your name, email address, telephone number, location, music-related information, teacher or student information, instrument details, photographs of instruments, and other information that you voluntarily submit through our forms.</p>

            <p>You agree that the information you provide is accurate and that you have the right to provide it.</p>

            <p>Our collection and use of personal information is described in our <strong>Privacy Policy</strong>.</p>

            <h2>3. Music Teacher Listings</h2>
            <p>Music teachers may register with the Website and provide information about themselves, their teaching experience, subjects or instruments taught, location, contact details, and other relevant information.</p>

            <p>Depending on the Website's features, some teacher information may be displayed publicly so that students and other users can discover teachers.</p>

            <p>Teachers are responsible for ensuring that the information they provide is accurate and appropriate.</p>

            <p>We reserve the right to review, edit, refuse, suspend, or remove any teacher listing at our discretion.</p>

            <p>A listing on our Website does not constitute an endorsement, certification, recommendation, or guarantee of a teacher's qualifications, experience, conduct, availability, or suitability.</p>

            <h2>4. Student Requests for Teacher Information</h2>
            <p>Students or other users may submit a form requesting information about a particular teacher.</p>

            <p>Where appropriate, we may share information provided by the student with the relevant teacher and may share relevant teacher information with the student.</p>

            <p>By submitting such a request, you acknowledge and consent to this information-sharing for the purpose of facilitating communication between students and teachers.</p>

            <h2>5. Student and Teacher Responsibility</h2>
            <p>Our Website may help students and teachers find or contact one another, but we are not a party to any agreement between a student and a teacher.</p>

            <p>We do not guarantee the qualifications, quality of teaching, availability, accuracy of information, conduct, safety, or suitability of any user or teaching arrangement.</p>

            <p>Students, parents, guardians, and teachers are responsible for making their own decisions and taking appropriate precautions when communicating or meeting with another person.</p>

            <p>Where a student is a minor, we strongly recommend that a parent or legal guardian be involved in communications, arrangements, and decisions concerning lessons or meetings.</p>

            <h2>6. Instrument Donations and Instrument Information</h2>
            <p>Users may submit information about musical instruments through our Website, including descriptions, specifications, photographs, and contact information.</p>

            <p>Submitting an instrument through the Website does not necessarily mean that we have accepted the instrument, agreed to collect it, or agreed to provide compensation.</p>

            <p>We may contact you to obtain additional information or to discuss the instrument.</p>

            <h2>7. Photographs and Other Content</h2>
            <p>When you upload or submit photographs, descriptions, text, or other material ("User Content"), you represent that you own the content or have permission to provide it and that it does not unlawfully infringe another person's rights.</p>

            <p>You grant us permission to use, reproduce, display, and process User Content as reasonably necessary to operate and provide the relevant Website service.</p>

            <p>We may remove content that we believe is inaccurate, inappropriate, unlawful, or inconsistent with these Terms.</p>

            <h2>8. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Provide false or misleading information;</li>
              <li>Impersonate another person;</li>
              <li>Use the Website for unlawful purposes;</li>
              <li>Harass, threaten, abuse, or exploit other users;</li>
              <li>Attempt to gain unauthorised access to the Website or another user's information;</li>
              <li>Submit malicious software or harmful material;</li>
              <li>Use information obtained through the Website for spam or unrelated commercial purposes;</li>
              <li>Scrape, copy, or systematically collect information from the Website without our permission; or</li>
              <li>Use the Website to facilitate fraudulent, abusive, or illegal activities.</li>
            </ul>

            <h2>9. Privacy</h2>
            <p>Our collection, use, disclosure, and retention of personal information is described in our <strong>Privacy Policy</strong>.</p>

            <h2>10. Account and Data Deletion</h2>
            <p>If the Website provides user accounts, you may request deletion of your account and associated publicly displayed information by following our <strong>Account and Data Deletion Policy</strong>.</p>

            <p>We aim to process valid deletion requests within <strong>7 days</strong> of receiving the request.</p>

            <p>Deletion of an account or removal of information from public display does not necessarily mean that every record is immediately and permanently erased from our systems.</p>

            <p>We may retain certain information where reasonably necessary for legal, regulatory, accounting, fraud prevention, security, dispute resolution, record-keeping, or other legitimate purposes.</p>

            <p>Retained information will not be publicly displayed or shared for ordinary Website purposes unless required or permitted by law or otherwise necessary for the purposes for which it is retained.</p>

            <h2>11. Intellectual Property</h2>
            <p>Unless otherwise stated, the Website and its original content, design, branding, text, graphics, logos, and other materials are owned by or licensed to <strong>SurSaathi</strong>.</p>

            <p>You may not reproduce, modify, distribute, sell, or commercially exploit our content without prior written permission, except where permitted by applicable law.</p>

            <h2>12. Third-Party Services and Links</h2>
            <p>The Website may contain links to third-party websites or use third-party services. We are not responsible for the content, privacy practices, security, availability, or activities of third-party websites or services.</p>

            <h2>13. Disclaimer</h2>
            <p>The Website and its services are provided on an "as is" and "as available" basis to the extent permitted by law.</p>

            <p>We do not guarantee that the Website will always be available, error-free, secure, or uninterrupted.</p>

            <h2>14. Limitation of Liability</h2>
            <p>To the maximum extent permitted by applicable law, <strong>SurSaathi</strong> and its owners, employees, volunteers, representatives, and affiliates will not be liable for indirect, incidental, special, consequential, or other losses arising from your use of the Website or interactions with other users.</p>

            <p>Nothing in these Terms excludes or limits liability that cannot legally be excluded or limited under applicable law.</p>

            <h2>15. Changes to These Terms</h2>
            <p>We may update these Terms from time to time. When we make changes, we may update the "Last Updated" date above.</p>

            <h2>16. Governing Law</h2>
            <p>These Terms shall be governed by the laws of <strong>India</strong>.</p>

            <h2>17. Contact Us</h2>
            <p>If you have questions about these Terms, please contact us:</p>

            <p>
              <strong>SurSaathi</strong><br />
              Email: sursaathi.music@gmail.com<br />
              Website: sursaathi.in<br />
            </p>
        </div>
      <Footer />
    </div>
  );
}